'use strict';

var _ = require('lodash');
var AdvancedHepExportToCsvService = function AdvancedHepExportToCsvService(advancedHepTransformationService) {
  var COMMA_SEPARATED_COLUMNS = ['benchmarkCarriers', 'daysOffsets', 'readingDays', 'benchmarkCarrier', 'competitorEntryLevelRbd', 'competitorEntryLevelRbds', 'approvedDaysOfWeek', 'include', 'exclude', 'flightNumbers', 'excludedDaysOfWeek', 'userName', 'inboundWeekendDefinition', 'outboundWeekendDefinition', 'exclusionReasons', 'fareTypeIndicator', 'competitorFareSource', 'mappedOwRt', 'fareSource', 'fareTariffNumber', 'hostFareBrand', 'competitorFareBrand', 'exclusionReasons', 'hostFareTypeIndicator', 'benchmarkFareTypeIndicator', 'fareBrand', 'neighborMarketCarriers', 'hostEntryLevelRbd', 'hostEntryLevelRBD', 'connectionOutbound', 'connectionInbound', 'carrierOutbound', 'carrierInbound', 'gds', 'value', 'foSeasons', 'hostRbd', 'fbcPattern', 'hostRbd', 'surchargeType', 'fbcMappingCompetitorFbc', 'competitorTariff', 'competitorAirline', 'competitorRouting', 'competitorFbcPattern', 'benchmarkFareComponent'];
  var FREE_TEXT_COLUMNS = ['description', 'fareBrandConfiguration', 'dates', 'propertyValue', 'fbcValue', 'marketGroup', 'marketType', 'marketAnalyst', 'marketCategory'];
  var COMMA_SEPARATED_WITH_PIPE_COLUMNS = ['filedDow'];
  var COMMA_SEPARATED_NUMBER_COLUMNS = ['propertyValue'];
  function formatAsCsvRow(stringArrayToFormat) {
    return stringArrayToFormat.join(',') + '\r\n';
  }
  function isCommaSeparatedValue(columnName) {
    return COMMA_SEPARATED_COLUMNS.indexOf(columnName) !== -1;
  }
  function isCommaSeparatedWithPipeValue(columnName) {
    return COMMA_SEPARATED_WITH_PIPE_COLUMNS.indexOf(columnName) !== -1;
  }
  function isCommaSeparatedNumbersValue(columnName, value) {
    return COMMA_SEPARATED_NUMBER_COLUMNS.indexOf(columnName) !== -1 && /^[1-7,]*$/.test(value);
  }
  function isFreeText(columnName) {
    return FREE_TEXT_COLUMNS.indexOf(columnName) !== -1;
  }
  function isBoolean(value) {
    return value === 'Yes' || value === 'No';
  }
  function formatValue(value, columnName) {
    if (_.isNil(value)) {
      return value;
    }
    if (_.isString(value) && isCommaSeparatedValue(columnName)) {
      var formatted = value.split(',').join('|');
      return '"' + formatted + '"';
    }
    if (_.isString(value) && (isCommaSeparatedWithPipeValue(columnName) || isCommaSeparatedNumbersValue(columnName, value))) {
      return '"' + value.split(',').join(';') + '"';
    }
    if (isFreeText(columnName)) {
      return '"' + value + '"';
    }
    if (isBoolean(value)) {
      return value === 'Yes';
    }
    if (columnName === 'departureDate') {
      return value.format('YYYY-MM-DD');
    }
    return value;
  }
  function getArrayProperties(exportColumns) {
    return _.chain(exportColumns).filter(function (value) {
      return !_.isUndefined(value.nested);
    }).map('name').value();
  }
  function createHeaderRow(exportColumns) {
    var header = _.transform(exportColumns, function (result, value) {
      if (_.isUndefined(value.nested)) {
        result.push(value.label);
      } else {
        _.forEach(value.nested, function (nestedColumn) {
          result.push(nestedColumn.label);
        });
      }
    }, []);
    return formatAsCsvRow(header);
  }
  function flattenByArrayProperty(transformedRow, exportColumns) {
    var flattenedRow = [];
    var arrayProperties = getArrayProperties(exportColumns);
    var arrayProperty = arrayProperties[0];
    populateFlattenedRows(arrayProperty, transformedRow, flattenedRow);
    var secondlyFlattenedRows = [];
    arrayProperty = arrayProperties[1];
    _.forEach(flattenedRow, function (flatRow) {
      populateFlattenedRows(arrayProperty, flatRow, secondlyFlattenedRows);
    });
    var thirdlyFlattenedRows = [];
    arrayProperty = arrayProperties[2];
    _.forEach(secondlyFlattenedRows, function (flatRow) {
      populateFlattenedRows(arrayProperty, flatRow, thirdlyFlattenedRows);
    });
    var fourthlyFlattenedRows = [];
    arrayProperty = arrayProperties[3];
    _.forEach(thirdlyFlattenedRows, function (flatRow) {
      populateFlattenedRows(arrayProperty, flatRow, fourthlyFlattenedRows);
    });
    return fourthlyFlattenedRows;
  }
  function populateFlattenedRows(arrayProperty, rowToFlat, outputFlattenedRows) {
    _.forEach(rowToFlat[arrayProperty], function (property) {
      var row = _.cloneDeep(rowToFlat);
      delete row[arrayProperty];
      _.forOwn(property, function (value, key) {
        if (!(arrayProperty === 'fareBasisCodePatternProperties' && key === 'fareTariffNumber')) {
          row[key] = value;
        }
      });
      outputFlattenedRows.push(row);
    });
    if (_.isUndefined(rowToFlat[arrayProperty]) || _.isEmpty(rowToFlat[arrayProperty])) {
      outputFlattenedRows.push(_.cloneDeep(rowToFlat));
    }
  }
  function createResultRow(flattenedRow, exportColumns) {
    var resultRow = [];
    _.forEach(exportColumns, function (column) {
      if (_.isUndefined(column.nested)) {
        resultRow.push(formatValue(flattenedRow[column.name], column.name));
      } else {
        _.forEach(column.nested, function (nestedExportColumn) {
          resultRow.push(formatValue(flattenedRow[nestedExportColumn.name], nestedExportColumn.name));
        });
      }
    });
    return resultRow;
  }
  function prepareMarketConfigData(data) {
    return _.transform(data, function (result, row) {
      var marketConfigPayload = advancedHepTransformationService.transformFpMarketConfigPayload(row, true);
      var transformedRow = marketConfigPayload.marketConfigRow;
      _.forEach(marketConfigPayload.modifyBenchmarkCarriers, function (benchmarkCarrierPayload) {
        var resultRow = _.cloneDeep(transformedRow);
        resultRow.cabinCode = benchmarkCarrierPayload.attributes.cabinCode;
        resultRow.benchmarkCarriers = benchmarkCarrierPayload.properties.benchmarkCarriers;
        result.push(resultRow);
      });
      if (_.isEmpty(marketConfigPayload.modifyBenchmarkCarriers)) {
        result.push(_.cloneDeep(transformedRow));
      }
    }, []);
  }
  function createFpMarketConfigExportData(data, exportColumns) {
    var fileData = createHeaderRow(exportColumns);
    var preparedData = prepareMarketConfigData(data);
    _.forEach(preparedData, function (row) {
      var flattenedRows = flattenByArrayProperty(_.cloneDeep(row), exportColumns);
      _.forEach(flattenedRows, function (flattenedRow) {
        fileData += formatAsCsvRow(createResultRow(flattenedRow, exportColumns));
      });
    });
    return fileData;
  }
  function createFOTacticalUserOverridesExportData(data, exportColumns) {
    _.forEach(data, function (row) {
      var todDefinition = getInboundOutboundTODFromList(row.timeOfDayPropertiesList);
      var proactiveBlackouts = getInboundOutboundProactiveBlackoutsFromList(row.proactiveBlackoutPropertiesList);
      row.inboundTimeOfDayDefinition = todDefinition.inboundTimeOfDayDefinition;
      row.outboundTimeOfDayDefinition = todDefinition.outboundTimeOfDayDefinition;
      row.inboundProactiveBlackouts = proactiveBlackouts.inboundProactiveBlackouts;
      row.outboundProactiveBlackouts = proactiveBlackouts.outboundProactiveBlackouts;
      delete row.timeOfDayPropertiesList;
      delete row.proactiveBlackoutPropertiesList;
    });
    return createNotNestedPropertiesExportData(data, exportColumns);
  }
  function getInboundOutboundTODFromList(todList) {
    var inboundTimeOfDayDefinition = [];
    var outboundTimeOfDayDefinition = [];
    _.forEach(todList, function (tod) {
      if (tod.inOrOutBoundType === 'IB') {
        inboundTimeOfDayDefinition.push(tod.start + '-' + tod.stop);
      } else {
        outboundTimeOfDayDefinition.push(tod.start + '-' + tod.stop);
      }
    });
    return {
      inboundTimeOfDayDefinition: inboundTimeOfDayDefinition.join('|'),
      outboundTimeOfDayDefinition: outboundTimeOfDayDefinition.join('|')
    };
  }
  function getInboundOutboundProactiveBlackoutsFromList(proactiveBlackoutsList) {
    var inboundProactiveBlackouts = [];
    var outboundProactiveBlackouts = [];
    _.forEach(proactiveBlackoutsList, function (row) {
      if (row.inOrOutBoundType === 'IB') {
        inboundProactiveBlackouts.push(getTransformedDate(row.begin.toISOString()) + '-' + getTransformedDate(row.end.toISOString()));
      } else {
        outboundProactiveBlackouts.push(getTransformedDate(row.begin.toISOString()) + '-' + getTransformedDate(row.end.toISOString()));
      }
    });
    return {
      inboundProactiveBlackouts: inboundProactiveBlackouts.join('|'),
      outboundProactiveBlackouts: outboundProactiveBlackouts.join('|')
    };
  }
  function getTransformedDate(date) {
    return _.replace(date, /-/g, '');
  }
  function createNotNestedPropertiesExportData(data, exportColumns) {
    var fileData = createHeaderRow(exportColumns);
    _.forEach(data, function (row) {
      fileData += formatAsCsvRow(createResultRow(row, exportColumns));
    });
    return fileData;
  }
  function createNestedPropertiesExportData(data, exportColumns) {
    var fileData = createHeaderRow(exportColumns);
    _.forEach(data, function (row) {
      var flattenedRows = flattenByArrayProperty(_.cloneDeep(row), exportColumns);
      _.forEach(flattenedRows, function (flattenedRow) {
        fileData += formatAsCsvRow(createResultRow(flattenedRow, exportColumns));
      });
    });
    return fileData;
  }
  return {
    createFOTacticalUserOverridesExportData: createFOTacticalUserOverridesExportData,
    createFpMarketConfigExportData: createFpMarketConfigExportData,
    createNotNestedPropertiesExportData: createNotNestedPropertiesExportData,
    createNestedPropertiesExportData: createNestedPropertiesExportData
  };
};
AdvancedHepExportToCsvService.$inject = ['AdvancedHepTransformationService'];
module.exports = AdvancedHepExportToCsvService;